import { render, staticRenderFns } from "./freightYS.vue?vue&type=template&id=583e6a00&scoped=true&"
import script from "./freightYS.vue?vue&type=script&lang=js&"
export * from "./freightYS.vue?vue&type=script&lang=js&"
import style0 from "./freightYS.vue?vue&type=style&index=0&id=583e6a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e6a00",
  null
  
)

export default component.exports